// extracted by mini-css-extract-plugin
export var avatarContainer = "_n-0";
export var avatarTypingWave = "_n-i";
export var gray = "_n-f";
export var green = "_n-c";
export var icon = "_n-9";
export var image = "_n-1";
export var lg = "_n-6";
export var md = "_n-5";
export var presenceDot = "_n-b";
export var red = "_n-d";
export var sm = "_n-4";
export var status = "_n-a";
export var typingDot = "_n-h";
export var typingPill = "_n-g";
export var xl = "_n-7";
export var xs = "_n-3";
export var xxl = "_n-8";
export var xxs = "_n-2";
export var yellow = "_n-e";